import { AngleMode, Cutout, MasonsMitreOrientationEnum, Milling, OutlineAngle, OutlineSide } from 'cloud-shared-lib';
import { CuttingFacadeSlot } from './cutting-facade-slot.model';
import { CuttingMaterial } from './cutting-material.model';

export class CuttingFacadeOutline {
  topLeft: OutlineAngle;
  topRight: OutlineAngle;
  bottomRight: OutlineAngle;
  bottomLeft: OutlineAngle;

  topSide: OutlineSide<CuttingFacadeSlot>;
  bottomSide: OutlineSide<CuttingFacadeSlot>;
  leftSide: OutlineSide<CuttingFacadeSlot>;
  rightSide: OutlineSide<CuttingFacadeSlot>;

  cutouts: Cutout[] = [];
  millings: Milling[] = [];
  filmMaterial: CuttingMaterial;

  constructor(outline?: CuttingFacadeOutline | any) {
    outline = outline || {};

    this.topSide =
      outline.topSide ||
      ({ groove: undefined, customHoles: [], fastenersSets: [], handle: null } as OutlineSide<CuttingFacadeSlot>);
    this.bottomSide =
      outline.bottomSide ||
      ({ groove: undefined, customHoles: [], fastenersSets: [], handle: null } as OutlineSide<CuttingFacadeSlot>);
    this.leftSide =
      outline.leftSide ||
      ({ groove: undefined, customHoles: [], fastenersSets: [], handle: null } as OutlineSide<CuttingFacadeSlot>);
    this.rightSide =
      outline.rightSide ||
      ({ groove: undefined, customHoles: [], fastenersSets: [], handle: null } as OutlineSide<CuttingFacadeSlot>);

    this.topLeft = outline.topLeft || {
      chamferLength: 0,
      rounding: 0,
      cutX: 0,
      cutY: 0,
      mode: AngleMode.None,
      roundingInside: 0,
      cutInsideX: 0,
      cutInsideY: 0,
      cutInsideR: 0,
      diagonalCut: false,
      butt: undefined,
      cutInsideWithAngle: { r: 0, x: 0, xA: 90, y: 0, yA: 90, x1: 0, y1: 0 },
      masonsMitreFemale: { allowance: 0, radius: 0, orientation: MasonsMitreOrientationEnum.AlongHeight, length: 100 },
      masonsMitreMale: { allowance: 0, radius: 0, orientation: MasonsMitreOrientationEnum.AlongWidth },
    };
    this.topRight = outline.topRight || {
      chamferLength: 0,
      rounding: 0,
      cutX: 0,
      cutY: 0,
      mode: AngleMode.None,
      roundingInside: 0,
      cutInsideX: 0,
      cutInsideY: 0,
      cutInsideR: 0,
      diagonalCut: false,
      butt: undefined,
      cutInsideWithAngle: { r: 0, x: 0, xA: 90, y: 0, yA: 90, x1: 0, y1: 0 },
      masonsMitreFemale: { allowance: 0, radius: 0, orientation: MasonsMitreOrientationEnum.AlongHeight, length: 100 },
      masonsMitreMale: { allowance: 0, radius: 0, orientation: MasonsMitreOrientationEnum.AlongWidth },
    };
    this.bottomRight = outline.bottomRight || {
      chamferLength: 0,
      rounding: 0,
      cutX: 0,
      cutY: 0,
      mode: AngleMode.None,
      roundingInside: 0,
      cutInsideX: 0,
      cutInsideY: 0,
      cutInsideR: 0,
      diagonalCut: false,
      butt: undefined,
      cutInsideWithAngle: { r: 0, x: 0, xA: 90, y: 0, yA: 90, x1: 0, y1: 0 },
      masonsMitreFemale: { allowance: 0, radius: 0, orientation: MasonsMitreOrientationEnum.AlongHeight, length: 100 },
      masonsMitreMale: { allowance: 0, radius: 0, orientation: MasonsMitreOrientationEnum.AlongWidth },
    };
    this.bottomLeft = outline.bottomLeft || {
      chamferLength: 0,
      rounding: 0,
      cutX: 0,
      cutY: 0,
      mode: AngleMode.None,
      roundingInside: 0,
      cutInsideX: 0,
      cutInsideY: 0,
      cutInsideR: 0,
      diagonalCut: false,
      butt: undefined,
      cutInsideWithAngle: { r: 0, x: 0, xA: 90, y: 0, yA: 90, x1: 0, y1: 0 },
      masonsMitreFemale: { allowance: 0, radius: 0, orientation: MasonsMitreOrientationEnum.AlongHeight, length: 100 },
      masonsMitreMale: { allowance: 0, radius: 0, orientation: MasonsMitreOrientationEnum.AlongWidth },
    };
  }
}
